// extracted by mini-css-extract-plugin
export var body = "B_B";
export var help = "B_bX";
export var informer = "B_bT";
export var informerSameSize = "B_bV";
export var postfix = "B_bW";
export var title = "B_w";